// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Y76ka","title":"FrontImage_title__926vi"};